<template>
    <div class="flex items-center justify-center">
        <div class="mb-10 xl:w-7/12 lg:w-10/12 w-full m-2">
            <Calendar></Calendar>
            <Menu></Menu>
            <Store></Store>
        </div>
    </div>
</template>
<script>
import Calendar from "@/components/CalendarComponent.vue";
import Menu from "@/components/MenuComponent.vue";
import Store from "@/components/StoreComponent.vue";
export default {
    components: {
        Calendar,
        Menu,
        Store
    }
}
</script>